import "./PatientsDataContent.scss";
import { PatientsList, Advertisement } from "../../../../../../components";
import { Details } from "../../../../../../modals";
import { useSelector } from "react-redux";

export default function PatientsDataContent({
  token,
  onListItemClick,
  handlePatientUpvote,
  selectedPatient,
  setSelectedPatient,
  is_detail_opened,
  set_is_detail_opened,
}) {
  const {
    patientsData: { results: patients },
    loading,
  } = useSelector((state) => state?.patients);

  return (
    <div className="patientDataContent-cont">
      <PatientsList
        token={token}
        patients={patients}
        loading={loading}
        onListItemClick={onListItemClick}
        handlePatientUpvote={handlePatientUpvote}
      />
      <Advertisement />
      <Details
        token={token}
        isOpened={is_detail_opened}
        patient={selectedPatient}
        setSelectedPatient={setSelectedPatient}
        onCancel={() => {
          set_is_detail_opened(false);
          setSelectedPatient(null);
        }}
        onOk={() => {
          set_is_detail_opened(false);
          setSelectedPatient(null);
        }}
      />
    </div>
  );
}
